import React from "react";

export const CenterSearch = ({
  value,
  onChange,
  isSearching,
  searchResults,
  onPlaceSelect,
}) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-brand-charcoal mb-2">
        Search Center
      </label>
      <div className="relative">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Search for a bowling center..."
          className="border border-brand-charcoal/20 p-3 rounded-lg w-full text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink"
        />

        {isSearching && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-brand-gold-ink"></div>
          </div>
        )}

        {searchResults.length > 0 && (
          <div className="absolute z-30 w-full mt-1 bg-white border border-brand-charcoal/10 rounded-lg shadow-lg max-h-72 overflow-y-auto">
            {searchResults.map((place) => (
              <div
                key={place.id}
                onClick={() => onPlaceSelect(place)}
                className="p-3 hover:bg-brand-cream cursor-pointer"
              >
                <div className="font-medium text-brand-charcoal">
                  {place.displayName.text}
                </div>
                <div className="text-sm text-brand-muted break-words">
                  {place.formattedAddress}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
